import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'booking-root',
    templateUrl: './booking.component.html',
    styleUrls: ['./booking.component.scss'],
    standalone: false
})
export class BookingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
